import { logEvent } from './eventLogging';

const logMatchAcceptDeclineView = () => {
  if (document.getElementById('match-accept-submit') !== null) {
    logEvent('match_accept_decline_page_viewed');
  }
};

const logPageViews = () => {
  document.addEventListener('turbolinks:load', logMatchAcceptDeclineView, { once: true });
};

export default logPageViews;
